import { put } from 'redux-saga/effects'

import { track as trackEvent } from '../../actions/tracking'

function* onHeroSectionClick() {
  yield put(trackEvent({ event: 'heroSection' }))
}

export default onHeroSectionClick
